var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "11",
        height: "20",
        viewBox: "0 0 11 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M5.45795 17.6367C5.15657 17.6367 4.9126 17.8761 4.9126 18.1719C4.9126 18.4677 5.15657 18.693 5.45795 18.693C5.75932 18.693 6.0033 18.4536 6.0033 18.1578C6.0033 17.8621 5.75932 17.6367 5.45795 17.6367Z",
          fill: "white",
          stroke: "white",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M1.15283 6.01759C1.15283 3.86278 2.80321 2.06006 4.97023 1.82064C7.1516 1.58122 9.16075 2.9755 9.64869 5.07398C10.1366 7.17245 8.94549 9.28501 6.89328 10.0033C6.03221 10.299 5.45817 11.1018 5.45817 11.9891V13.4115",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }